export const TYPEBOOKING_EBOOKING = 'e-booking';

export const TOUR_TYPE_GIR = 1;
export const TOUR_TYPE_FIT = 2;
